import React, { useState } from 'react';
import { Container } from './styles';
import { Title, Select, TextField } from '@gerdau/hefesto';
import { cnpjMask, phoneMask } from '../../../../../../utils/formatStrings';
import { RewardBeneficiary } from '../index';
interface FormProps {
  beneficiary: RewardBeneficiary;
  onChangeBeneficiaryData: (beneficiaryData: RewardBeneficiary) => void;
  index: number;
}
const Form: React.FC<FormProps> = ({
  beneficiary,
  onChangeBeneficiaryData,
  index
}) => {
  const [rewardSelected, setRewardSelected] = useState(beneficiary.rewardType);
  const getRewardsOptions = () => {
    const rewards = [];
    rewards.push({
      label: 'Marketing',
      value: 'Marketing'
    });
    rewards.push({
      label: 'Campanhas',
      value: 'Campanhas'
    });
    rewards.push({
      label: 'Infraestrutura',
      value: 'Infraestrutura'
    });
    rewards.push({
      label: 'Capacitação',
      value: 'Capacitação'
    });
    return rewards;
  };
  const getDisplayValue = (value: string | null) => {
    if (value === null) {
      return '';
    }
    const displayValue = parseFloat(value);
    if (isNaN(displayValue)) {
      return value;
    }
    const formatedDisplayValue = displayValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    return formatedDisplayValue;
  };
  return (
    <Container>
      <div className="beneficiary-form">
        <div className="top-form">
          <div className="left-title">
            <Title level={3}>{'Beneficiário ' + index + ':'}</Title>
          </div>
        </div>
        <div className="form-fields">
          <div className="field-line">
            <TextField
              label="Razão Social"
              placeholder=""
              name="CompanyName"
              minLength={1}
              maxLength={115}
              disabled={false}
              value={beneficiary.companyName}
              onChange={(e) => {
                onChangeBeneficiaryData({
                  ...beneficiary,
                  companyName: e.target.value
                });
              }}
            />
          </div>
          <div className="field">
            <TextField
              label="CNPJ"
              placeholder="00.000.000/0000-00"
              name="companyTaxVat"
              minLength={1}
              maxLength={18}
              disabled={false}
              value={cnpjMask(
                beneficiary.companyTaxVat ? beneficiary.companyTaxVat : ''
              )}
              onChange={(e) => {
                onChangeBeneficiaryData({
                  ...beneficiary,
                  companyTaxVat: e.target.value
                });
              }}
            />
          </div>
          <div className="field">
            <Select
              data-testid="type"
              label="Premiação referente a"
              disabled={beneficiary.locked}
              name="SelectedReward"
              value={rewardSelected}
              options={getRewardsOptions()}
              placeholder={`- Selecione -`}
              onSelect={(value) => {
                onChangeBeneficiaryData({
                  ...beneficiary,
                  rewardType: value.toString()
                });
                setRewardSelected(value.toString());
              }}
            ></Select>
          </div>
          <div className="field-line">
            <TextField
              label="Endereço para envio"
              placeholder=""
              name="address"
              minLength={100}
              maxLength={100}
              disabled={false}
              value={beneficiary.address}
              onChange={(e) => {
                onChangeBeneficiaryData({
                  ...beneficiary,
                  address: e.target.value
                });
              }}
            />
          </div>
          <div className="field">
            <TextField
              label="Telefone"
              placeholder="(00)00000-0000"
              name="phone"
              minLength={1}
              maxLength={11}
              disabled={false}
              value={phoneMask(beneficiary.phone ? beneficiary.phone : '')}
              onChange={(e) => {
                onChangeBeneficiaryData({
                  ...beneficiary,
                  phone: e.target.value
                });
              }}
            />
          </div>
          <div className="field">
            <TextField
              label="Valor do cartão"
              placeholder="R$ 0,00"
              name="value"
              minLength={1}
              maxLength={10}
              disabled={true}
              value={getDisplayValue(
                beneficiary.rewardValue
                  ? beneficiary.rewardValue.toString()
                  : ''
              )}
              onChange={(e) => {
                onChangeBeneficiaryData({
                  ...beneficiary,
                  rewardValue: e.target.value
                });
              }}
            />
          </div>
        </div>
      </div>
      <div className="middle-line">
        <hr></hr>
      </div>
    </Container>
  );
};

export default Form;
